
import React, { useState } from "react";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";

interface ApproveWorksheetDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onSubmit: (status: "APPROVED" | "REJECTED" | "NO_PROBLEM_REPORT", note: string) => Promise<void>;
  loading: boolean;
  initialStatus?: "WAITING" | "APPROVED" | "REJECTED" | "NO_PROBLEM_REPORT";
  initialNote?: string;
  isEditing?: boolean;
}

export const ApproveWorksheetDialog: React.FC<ApproveWorksheetDialogProps> = ({
  open,
  onOpenChange,
  onSubmit,
  loading,
  initialStatus = "WAITING",
  initialNote = "",
  isEditing = false
}) => {
  const [status, setStatus] = useState<"APPROVED" | "REJECTED" | "NO_PROBLEM_REPORT">(
    initialStatus === "WAITING" ? "APPROVED" : initialStatus === "NO_PROBLEM_REPORT" ? "NO_PROBLEM_REPORT" : initialStatus as "APPROVED" | "REJECTED"
  );
  const [note, setNote] = useState(initialNote);

  const handleSubmit = () => {
    onSubmit(status, note);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>{isEditing ? "แก้ไขสถานะ Worksheet" : "ตรวจสอบ Worksheet"}</DialogTitle>
        </DialogHeader>
        <div className="space-y-4 py-4">
          <RadioGroup
            value={status}
            onValueChange={(value) => setStatus(value as "APPROVED" | "REJECTED" | "NO_PROBLEM_REPORT")}
            className="flex flex-col space-y-2"
          >
            <div className="flex items-center space-x-2">
              <RadioGroupItem value="APPROVED" id="approved" />
              <Label htmlFor="approved" className="text-green-600">อนุมัติแล้ว</Label>
            </div>
            <div className="flex items-center space-x-2">
              <RadioGroupItem value="REJECTED" id="rejected" />
              <Label htmlFor="rejected" className="text-red-600">ไม่อนุมัติ</Label>
            </div>
            <div className="flex items-center space-x-2">
              <RadioGroupItem value="NO_PROBLEM_REPORT" id="no-problem" />
              <Label htmlFor="no-problem" className="text-blue-600">ไม่ได้รายงานปัญหา</Label>
            </div>
          </RadioGroup>
          
          <div className="space-y-2">
            <Label htmlFor="note">หมายเหตุ</Label>
            <Textarea
              id="note"
              value={note}
              onChange={(e) => setNote(e.target.value)}
              placeholder="ระบุเหตุผลหรือหมายเหตุเพิ่มเติม (ถ้ามี)"
              className="resize-none"
              rows={4}
            />
          </div>
        </div>
        <DialogFooter>
          <Button
            type="button"
            variant="outline"
            onClick={() => onOpenChange(false)}
            disabled={loading}
          >
            ยกเลิก
          </Button>
          <Button 
            type="button" 
            onClick={handleSubmit} 
            disabled={loading}
          >
            {loading ? "กำลังบันทึก..." : "บันทึก"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
